import {Component, HostListener, inject, Input} from '@angular/core';
import {CommonModule} from '@angular/common';
import {BaseComponent} from '../../../components/base/base.component';
import {WmsFeatureDirective} from '@wms/directives';
import {NotificationService, ProjectUpdatesService, StudioService} from '@wms/services';
import {VcsAPIService} from '../../services/vcs-api/vcs-api.service';
import {hideMsg} from '../../utils/vcs-utils';
import {VcsService} from '../../services/vcs.service';
import {WmsWorkspaceManagerService} from "@wms/workspace";
import {BsDropdownDirective} from "ngx-bootstrap/dropdown";
import {handleInvalidRepoBranch} from "@wms/core";

@Component({
  standalone: true,
  selector: 'wms-vcs-menu-item',
  templateUrl: './wms-vcs-menu-item.component.html',
  styleUrls: ['./wms-vcs-menu-item.component.less'],
  imports: [
    CommonModule,
    WmsFeatureDirective,
  ],
})

export class WmsVcsMenuItemComponent extends BaseComponent {
  @Input() dropdown:BsDropdownDirective;
  private vcsAPIService: VcsAPIService;
  private notificationService: NotificationService;
  public vcsService: VcsService;
  public wsManager: WmsWorkspaceManagerService;
  public studioService: StudioService;
  public projectUpdatesService: ProjectUpdatesService;

  constructor() {
    super();
    this.vcsAPIService = inject(VcsAPIService);
    this.notificationService = inject(NotificationService);
    this.vcsService = inject(VcsService);
    this.wsManager = inject(WmsWorkspaceManagerService);
    this.studioService = inject(StudioService);
    this.projectUpdatesService = inject(ProjectUpdatesService);
  }

  @HostListener('document:keydown', ['$event'])
  onKeydownHandler(event: KeyboardEvent) {
    if (event.key === 'Escape' && this.dropdown.isOpen) {
      this.dropdown.isOpen = false;
    }
  }

  async viewProjectChanges(): Promise<void> {
    this.vcsService.msgData = hideMsg();
    this.vcsAPIService.loadChanges().then((response): any => {
      this.vcsService.openViewChangesDialogue(response)
    });
  }

  viewHistory() {
    this.vcsService.offset = 0;
    this.vcsService.isDisableNext = true;
    this.vcsService.isDisablePrevious = true;
    this.vcsService.openDialogWithId('commitHistoryModal');
    this.vcsService.getCommitsLog();
    this.vcsService.getGitStatus();
  }

  mergeConflicts() {}

  addProjectToExternalVCS() {
  /*Before pushing to external repo check whether the current project is upto-date*/
    this.vcsAPIService.getChangesDetails().then((response): void => {
      if(!!response.unPushedChanges) {
        this.vcsService.hasVCSChanges = true
        this.vcsService.openDialogWithId('pushExternalRepoChangesModal');
      } else {
        this.vcsService.vcsBranchName = 'master'
        this.vcsService.selectVCSProvider()
        this.vcsService.openDialogWithId('pushToExternalVCSModal');
      }
    });
  }

  callVCSActionFn(vcsAction:string) {
    if (handleInvalidRepoBranch()) return;
    this.vcsService.vcsAction = vcsAction;
    this.wsManager.triggerSaveImmediately = true;
    this.wsManager.saveActiveWs.next(() => this.vcsCallback(vcsAction));
  }

  vcsCallback(vcsAction: string) {
    if (vcsAction === 'push') {
      this.vcsService.openPushProjectDialog();
    } else if(vcsAction === 'pull'){
      this.vcsService.openDialogWithId('pullChangesModal')
    }else if(vcsAction === 'view'){
      this.viewProjectChanges()
    }else if(vcsAction === 'commit-history'){
      this.viewHistory()
    }else if(vcsAction === 'pushtoExternalRepo'){
      this.addProjectToExternalVCS()
    }
  }
  openVCSCredentialsDialog(){
    if (handleInvalidRepoBranch()) return;
    this.vcsService.showUserVCSCredentialsDialog('','')
  }
}
